import { Record } from 'immutable';
import { makeReducer, match } from 'web-app/util/redux';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';
import * as Actions from './actions';
export class InstitutionOverviewState extends Record({
    employeeEstimatedCheckoutTimeEnabled: false,
    features: [],
    groups: [],
    institution: undefined,
    labels: {},
    openingHours: [],
    hiddenGroupIds: [],
    behaviors: new BehaviorsCollection([]),
}) {
}
export default makeReducer([
    match(Actions.fetchOverviewSuccess, (state, { payload }) => {
        return state.merge(payload.institutionOverview);
    }),
    match(Actions.updateHiddenGroups, (state, { payload }) => {
        return state.merge({
            hiddenGroupIds: payload.hiddenGroupIds,
        });
    }),
], new InstitutionOverviewState());
